import React, { useEffect, useRef, useCallback } from 'react';
import { useMapState } from 'rooks';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { initCustomerInfo } from '@store/actions/customerAction';
// //import firebase from 'firebase/app';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import SearchCustomer from '@components/common/biz/SearchCustomer';
import { RegisterCorporate } from '@container/customer';

const HomeMainSearchCustomer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const inputRef = useRef();
  const { customerInfo } = useSelector(state => state.customerReducer);

  const [modalState, { set: setModal }] = useMapState({
    isShowSearchModal: false,
    isShowCorporateModal: false,
  });

  useEffect(() => {
    const { location } = history;

    if (location.state?.enrollCorporation) {
      if (customerInfo) {
        dispatch(initCustomerInfo());
      }
      setModal('isShowCorporateModal', true);
    } else if (customerInfo) {
      history.push('/home/customerInfo');
    }
  }, [customerInfo]);

  useEffect(() => {
    if (!modalState) inputRef.current.onBlur();
  }, [modalState]);

  useEffect(() => {
    // firebase.analytics().logEvent('screen_view', {
    //   firebase_screen: '홈',
    //   firebase_screen_class: 'Home',
    // });
  }, []);

  const handleSelectedCustomer = useCallback(customer => {
    history.push({
      pathname: '/home/customerInfo',
      state: { custNo: customer.custNo },
    });
  }, []);

  return (
    <>
      <div className="half app-box-main">
        <div className="ico-group-2 ico-new-search">
          <h3 className="tit3">고객검색</h3>
        </div>

        <SatInput
          customStyleClass="mt-15"
          customInputClass="line1"
          ref={inputRef}
          placeholder="이름으로 고객을 검색하세요."
          onClick={() => setModal('isShowSearchModal', true)}
          suffix={() => (
            <SatButton
              styleClass="ico ico-search"
              onClick={() => setModal('isShowSearchModal', true)}
            />
          )}
        />

        <div className="customer-type-box text-center">
          <SatButton
            label="법인 고객 등록"
            styleClass="btn-round"
            iconStyleClass="ico ico-com"
            onClick={() => setModal('isShowCorporateModal', true)}
          />

          <SatButton
            label="개인 고객 등록"
            styleClass="btn-round mgl-16"
            iconStyleClass="ico ico-personal"
            onClick={() =>
              history.push({ pathname: '/customer/register-individual' })
            }
          />
        </div>
      </div>

      <SatModal
        visible={modalState.isShowSearchModal}
        setVisible={() => setModal('isShowSearchModal', false)}
        type="info"
        wide
      >
        <SearchCustomer
          title={'고객검색'}
          onSelectCustomer={handleSelectedCustomer}
          onEnrollCorporation={() => {
            setModal('isShowSearchModal', false);
          }}
        />
      </SatModal>

      <RegisterCorporate
        isModal
        isOpen={modalState.isShowCorporateModal}
        onClose={() => setModal('isShowCorporateModal', false)}
      />
    </>
  );
};

export default HomeMainSearchCustomer;
